import dayjs, { Dayjs } from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import { EmptyText, FORMAT_DATE_TIME } from 'src/utils/constants/config';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(minMax);

type TypeFormatDateTime = (typeof FORMAT_DATE_TIME)[keyof typeof FORMAT_DATE_TIME];

export const formatTimeUTCToFromNow = (time: string) => {
  return dayjs.utc(time).local().fromNow();
};

export const formatUTCTime = (format: string, time?: string, utcFormat = FORMAT_DATE_TIME.UTC) => {
  if (!time) {
    return EmptyText;
  }
  const dayObject = dayjs(time, utcFormat);
  if(!dayObject.isValid()) return EmptyText;
  const formattedDate = dayObject.format(format);
  return formattedDate;
};

export const formatTimeToUTC = (time: Dayjs | null) => {
  return dayjs(time).utc().format(FORMAT_DATE_TIME.UTC);
};

export const getPeriodOfMonths = (start: string, end: string) => {
  return dayjs(formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, end || ''), FORMAT_DATE_TIME.FULL_ONLY_DATE).diff(
    dayjs(formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, start || ''), FORMAT_DATE_TIME.FULL_ONLY_DATE),
    'month',
  );
};

export const getTradeDataEndMonth = (date?: Dayjs) => {
  if (!date) return dayjs();
  return dayjs.min(dayjs(), date.endOf('month'));
};

export const getDatePickerValue = (format: TypeFormatDateTime, date?: ExpectedAny, defaultValue?: ExpectedAny) => {
  if (!date) return defaultValue ?? null

  const isValid = dayjs(date, format).isValid()
  if (isValid) {
    return dayjs(date, format)
  }
  return defaultValue ?? null
}
export const handleDatePickerValueChange = (format: TypeFormatDateTime, value: Dayjs | null,
) => {
  if (value) {
    return dayjs(value).format(format)
  }
  return null
}

export const getTradeDataStartMonth = (date?: Dayjs) => {
  if (!date) return dayjs();
  return date?.startOf('month');
  // return dayjs.min(dayjs(), date.endOf('month'));
};
